import { Navigate } from "react-router-dom";
import PublicValidator from "./validators/PublicValidator";
import AboutUs from "../Modules/Commonpages/AboutUs";
import Contact from "../Modules/Commonpages/Contact";
import Legal from "../Modules/Commonpages/Legal";
import StartPage from "../Modules/session/StartPage";
import Credit from "../Modules/Commonpages/Credit";


const Public = [
  {
    path: `${process.env.REACT_APP_FRONT_URL}`,
    element: <PublicValidator />,
    children: [
      {
        path: "about-us",
        element: <AboutUs />,
      },
      {
        path: "contact-us",
        element: <Contact />,
      },
      {
        path: "legal",
        element: <Legal />,
      },
      {
        path: "credit",
        element: <Credit />,
      },
      {
        path: "",
        element: <StartPage />,
      },
    ],
  },
  {
    path: "/*",
    element: <Navigate to={`${process.env.REACT_APP_FRONT_URL}`} />,
  },
];

export default Public;
